import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type { IAcceptOfficeConsentContentParameters } from '../types/OfficeConsentContent.parameters';

export const acceptOfficeConsentContent = async (
  params: IAcceptOfficeConsentContentParameters,
): Promise<void> => {
  const baseHeaders = params.accessToken
    ? { Authorization: params.accessToken }
    : await getAuthHeaders();

  await tempMeeApi.post(
    `/credential-service/office/consents/${params.code}/accept-all`,
    {},
    {
      headers: {
        ...baseHeaders,
        'x-office': params.officeId,
      },
    },
  );
};
